<template>
  <v-container
    v-if="loading"
    fluid
    class="d-flex align-center justify-center fill-height"
  >
    <v-progress-circular
      indeterminate
      color="primary"
      size="50"
    />
  </v-container>
  <NoAccessState
    v-if="accessPrivilege.indexOf('list') < 0 && !loading"
    subtitle="You don't have permission to view QC Error Approval."
  />
  <v-card flat class="px-4 pb-4 my-4" v-if="accessPrivilege.indexOf('list') >= 0" height="89vh">
    <QcExceptionHeader
      :workSpaceData="workSpaceData"
      :accountData="accountData"
      :projectData="projectData"
      :nextActionData="nextActionData"
      :title = "'QC Error Approval'"
      :formData="formData"
      :showReadOnly="showReadOnly"
      @update:formData="formData = $event"
      @apply="filterException()"
    />
    <QcExceptionTable
      :tableData="tableData"
      :columns="columns"
      :skeleLoading="skeleLoading"
      :title="'QC Error Approval'"
      @add="openDialog(null)"
      @download="handleDownload"
      @approve="openDialog($event, 'approve')"
      @reject="openDialog($event, 'reject')"
      @dateChanged="onDateChanged"
      :showDateRange="false"
    />

    <!-- Create / Edit / View dialog -->
    <v-dialog v-if="dialog" v-model="dialog" persistent width="800px">
      <v-card>
        <v-card-title class="pa-4 dlg-head text-subtitle-1  font-weight-bold">
          <!-- <div class="d-flex justify-between"> -->
            <span>{{ viewType === 'approve' ? 'Approval Remarks' : ' Reject Remarks'}} </span>
            <v-btn
              icon
              variant="text"
              density="compact"
              @click="closeDialog"
            >
            <v-icon>mdi-close</v-icon>
            </v-btn>
          <!-- </div> -->
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-col cols="12">
            <v-label>Remarks</v-label>
            <TextArea v-model="remarks_description" />
          </v-col>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4 justify-end">
          <v-btn variant="text" @click="closeDialog">Cancel</v-btn>
          <v-btn color="primary" elevation="0" :loading="saveLoading" @click="saveApproval(viewType)">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import QcExceptionTable from './QcExceptionTable.vue';
import QcExceptionHeader from './QcExceptionHeader.vue';
import NoAccessState from '@/components/ui/NoAccessState.vue';
import ErrorLogsService from '@/api/service/ErrorLogs/ErrorLogsService';
import WorkSpaceService from '@/api/service/WorkSpace/WorkSpaceService';
import ProjectService from '@/api/service/Project/ProjectService';
import AccountService from '@/api/service/Account/AccountService';
import UserService from '@/api/service/User/UserService';
import TextArea from '@/components/ui/TextArea.vue';
import commonService from '@/common.service';
import QcExceptionRemovalLogService from '@/api/service/QcExceptionRemovalLogs/QcExceptionRemovalLogService';
// admin/src/api/service/ErrorLogs/ErrorLogsService.js
// import QcExceptionService from '@/api/service/QcException/QcExceptionService';

export default {
  name: 'QcException',

  components: {
    QcExceptionTable,
    QcExceptionHeader,
    NoAccessState,
    TextArea,
  },

  data() {
    return {
      loading: false,
      saveLoading: false,
      skeleLoading:false,
      dialog: false,
      editId: null,
      editRow: null,
      viewType: null,
      remarks_description: '',
      workSpaceData:[],
      accessPrivilege:[],
      accountData:[],
      projectData:[],
      nextActionData:[],
      formData:{
        workSpace:[],
        account:[],
        project:[],
        nextAction:[]
      },

      columns: [
        {
          field: 'reference_num',
          header: 'Ref #',
          width: '160px',
          sortable: true,
        },
        {
          field: 'qc_reference_num',
          header: 'Qc Ref #',
          width: '200px',
          sortable: true,
        },
         {
          field: 'error_made_by',
          header: 'Error Made By',
          width: '160px',
          sortable: true,
        },
        {
          field: 'section',
          header: 'Section',
          width: '140px',
          sortable: true,
        },
        {
          field: 'severity',
          header: 'Error Severity',
          width: '180px',
          sortable: true,
        },
        {
          field: 'errorType',
          header: 'Error Type[E]',
          width: '140px',
          sortable: true,
        },
        {
          field: 'errorCategory',
          header: 'Error Category[E]',
          width: '140px',
          sortable: true,
        },
        {
          field: 'errorCode',
          header: 'Error Code',
          width: '100px',
          sortable: true,
        },
        {
          field: 'description',
          header: 'description',
          width: '110px',
          sortable: true,
        },
      ],

      tableData: [],
      allTableData: [],
      weekRange: {},
    };
  },

  async created(){
    this.loading = true
    try {
      const res = await commonService.isAllowed('QCA')
      this.accessPrivilege = res
    } catch (error) {
      console.error(error)
    } finally {
      this.loading = false
    }
  },
  // Initial load is triggered by @weekChanged emitted from QcExceptionTable on mount

  methods: {
    async fetchData(params = {}) {
      try {
        this.skeleLoading = true;
        const res = await ErrorLogsService.getQcException({...params,request_to_remove:1});
        this.allTableData = res.data.data || [];
        this.tableData = [...this.allTableData];
      } catch (err) {
        console.error('Failed to load QC exceptions:', err);
        this.allTableData = [];
        this.tableData = [];
      } finally {
        this.skeleLoading = false;
      }
    },

    filterException() {
      const { workSpace, account, project, nextAction } = this.formData;
      this.tableData = this.allTableData.filter(item => {
        const wsMatch      = !workSpace.length  || workSpace.includes(item.workspace_name);
        const accMatch     = !account.length    || account.includes(item.account_name);
        const projMatch    = !project.length    || project.includes(item.project_name);
        const actionMatch  = !nextAction.length || nextAction.includes(item.qa_user);
        return wsMatch && accMatch && projMatch && actionMatch;
      });
    },

    async getNextAction() {
      try {
        this.nextActionData = await UserService.findAll({ active: 1 });
      } catch (error) {
        this.nextActionData = [];
      }
    },

    async getAccount() {
      try {
        this.accountData = await AccountService.findAll({ active: 1 });
      } catch (error) {
        this.accountData = [];
      }
    },

    async getProject() {
      try {
        this.projectData = await ProjectService.findAll({ active: 1 });
      } catch (error) {
        this.projectData = [];
      }
    },

    async getWorkSpace() {
      try {
          let workSpace = await WorkSpaceService.getWorkSpaceByUser({ active: 1 })
          this.workSpaceData = workSpace.length > 0 ? workSpace : [];
      } catch (error) {
          this.workSpaceData = [];
          console.log(error, 'error');
      }
    },

    openDialog(row, type = null) {
      this.editId = row?.id || null;
      this.editRow = row || null;
      this.viewType = type;
      this.remarks_description = '';
      this.dialog = true;
    },

    closeDialog() {
      this.dialog = false;
      this.editId = null;
      this.editRow = null;
      this.viewType = null;
      this.remarks_description = '';
    },

    async saveApproval(type) {
      console.log(type,"type",this.remarks_description);
      
      this.saveLoading = true;
      try {
        // const res = await ErrorLogsService.generateUniqueCode();
        const previewSection = JSON.parse(this.editRow?.preview_section || '[]');
        console.log(this.editRow,"this.editRow");
        
        const updatedPreview = previewSection.map(item =>
          (type == "approve" && item.unique_code == this.editRow.unique_code)
            ? {
                ...item,
                deleted: 1
              }
            :
          (type == "reject" && item.unique_code == this.editRow.unique_code)
            ? {
                ...item,
                request_to_remove: 2,
            }
            : item
        );
        console.log('updatedPreview', updatedPreview);
        // const { ...dbFields } = this.editRow;
        const updatedRow = {
          id: this.editRow.id,
          preview_section: updatedPreview,
        };

        const removal_data = {
          issue_id : this.editRow.issue_id,
          qc_issue_id : this.editRow.qc_issue_id,
          error_log_id: this.editRow.id,
          unique_code: this.editRow.unique_code,
          action_by : JSON.parse(localStorage.getItem('user_details'))?.id,
          action_date : new Date().toISOString().slice(0, 19).replace('T', ' '),
          status : type == 'approve'? 'APPROVED' : 'REJECTED',
          remarks : this.remarks_description
        };

        const update_removal = {
          id: this.editRow.approval_id,
          status: type == 'approve'? 'APPROVED' : 'REJECTED',
          remarks : this.remarks_description,
          action_by : JSON.parse(localStorage.getItem('user_details'))?.id,
          action_date : new Date().toISOString().slice(0, 19).replace('T', ' '),
        }
        console.log(removal_data,"removal_data")
        console.log(updatedRow,"updatedRowupdatedRowupdatedRowupdatedRow");
        
        await ErrorLogsService.update(updatedRow);
        if(this.editRow.approval_id){
          await QcExceptionRemovalLogService.update(update_removal);
        } else {
          await QcExceptionRemovalLogService.create(removal_data);
        }
        this.closeDialog();
        this.fetchData(this.weekRange);
      } catch (err) {
        console.error('Failed to save approval:', err);
      } finally {
        this.saveLoading = false;
      }
    },

    handleDelete(row) {
      console.log('Delete row:', row);
      // Add confirmation + service call here
    },

    handleDownload() {
      console.log('Download triggered');
      // Wire up export logic here
    },

    onDateChanged({ start_date, end_date }) {
      this.weekRange = { start_date, end_date };
      this.fetchData(this.weekRange);
    },
  },

  mounted() {
    this.getWorkSpace();
    this.getAccount();
    this.getProject();
    this.getNextAction();
    // Initial fetch (will be overridden by first week change event)
    this.fetchData();
  },
};
</script>

<style scoped>
  .dlg-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .qca-no-access {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 89vh;
    font-family: 'Inter', 'Roboto', sans-serif;
  }

  .qca-no-access-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 48px 40px;
    background: #ffffff;
    border: 1px solid #e5e7eb;
    border-radius: 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,.06), 0 4px 16px rgba(0,0,0,.04);
    text-align: center;
    max-width: 380px;
  }

  .qca-no-access-icon {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: #f9fafb;
    border: 1px solid #e5e7eb;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .qca-no-access-title {
    font-size: 15px;
    font-weight: 700;
    color: #111827;
    margin: 0;
  }

  .qca-no-access-sub {
    font-size: 13px;
    color: #9ca3af;
    margin: 0;
    line-height: 1.6;
  }
</style>
